<form *ngIf="form" [formGroup]="form">
  <app-form-field *ngIf="personas.length" [formFieldId]="'persona'" [label]="'Persona'" [tooltip]="getTooltip(settingsItemsEnum.persona)">
    <p-dropdown id="persona" [(ngModel)]="selectedPersona" [options]="personas" optionLabel="name"
                (onChange)="handlePersonaChanged($event)" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
  </app-form-field>
  <div class="d-flex justify-content-end pt-2">
    <button pButton pRipple label="Reset to default" (click)="resetToDefaultSettings()" [loading]="false"></button>
  </div>
  <hr/>
  <div class="d-flex flex-column gap-2 mt-2">
    <app-form-field [formFieldId]="'deploymentId'" [label]="'Model'">
      <p-dropdown
        id="deploymentId"
        class="w-100"
        [(ngModel)]="selectedModel"
        [options]="models"
        optionLabel="modelFriendlyName"
        optionValue="id"
        (onChange)="modelChanged($event)"
        [ngModelOptions]="{standalone: true}"
        appendTo="body"
      >
        <ng-template pTemplate="item" let-item>
          <div [class.opacity-50]="!item.enabled" [class.pointer-events-none]="!item.enabled" (click)="onItemClicked($event, item)">
            <span>
              {{ item.modelFriendlyName }}
            </span>
            <span *ngIf="item.note">
              <i class="pi pi-info-circle m-2 cursor-pointer" [pTooltip]="item.note"></i>
            </span>
          </div>
        </ng-template>
      </p-dropdown>
    </app-form-field>
    <app-form-field [formFieldId]="'prompt'" [label]="'Prompt'" [tooltip]="getTooltip(settingsItemsEnum.prompt)">
      <textarea pInputTextarea id="prompt" class="w-100" formControlName="prompt" type="text" rows="6"></textarea>
    </app-form-field>

    <app-form-field [formFieldId]="'maxTokens'" [label]="'Max response'" [tooltip]="getTooltip(settingsItemsEnum.maxTokens)">
      <input pInputText id="maxTokens" class="w-100" formControlName="maxTokens" type="number" [min]="settingsRanges.maxTokensMin"
             [max]="settingsService.selectedModel.maxResponseTokens" [step]="1">
      <p-slider id="maxTokensSlider" formControlName="maxTokens" [min]="settingsRanges.maxTokensMin"
                [max]="settingsService.selectedModel.maxResponseTokens" [step]="1"></p-slider>
    </app-form-field>

    <app-form-field [formFieldId]="'lastMessages'" [label]="'Last messages'" [tooltip]="getTooltip(settingsItemsEnum.lastMessages)">
      <input pInputText id="lastMessages" class="w-100" formControlName="lastMessages" type="number" [min]="settingsRanges.lastMessagesMin"
             [max]="settingsRanges.lastMessagesMax" [step]="1">
      <p-slider id="lastMessagesSlider" formControlName="lastMessages" [min]="settingsRanges.lastMessagesMin"
                [max]="settingsRanges.lastMessagesMax" [step]="1"></p-slider>
    </app-form-field>

    <app-form-field [formFieldId]="'reasoningEffortLevel'" [label]="'Reasoning effort level'" [tooltip]="getTooltip(settingsItemsEnum.reasoningEffortLevel)">
      <p-dropdown id="reasoningEffortLevel" formControlName="reasoningEffortLevel" [options]="reasoningEffortLevelOptions"
                optionLabel="label" optionValue="value" placeholder="Select reasoning effort level" appendTo="body"></p-dropdown>
    </app-form-field>
  </div>
</form>
